const DESKTOP_MEDIA_QUERY = "(min-width: 1200px)";

const initProductLinkTrigger = (root) => {
    const trigger = root.querySelector("[data-product-link-trigger]");
    if (!trigger) return;

    trigger.addEventListener("click", (event) => {
        const inputId = window.matchMedia(DESKTOP_MEDIA_QUERY).matches
            ? "haitao-shop-landing-hero-product-url-desktop"
            : "haitao-shop-landing-hero-product-url-mobile";
        const input = root.querySelector(`#${inputId}`);
        if (!input) return;

        event.preventDefault();
        input.focus({ preventScroll: true });
        input.scrollIntoView({
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
                .matches
                ? "auto"
                : "smooth",
            block: "center",
        });
    });
};

const initHero = (root) => {
    initProductLinkTrigger(root);
};

export { initHero };
